import { render, staticRenderFns } from "./license-agreement.vue?vue&type=template&id=7b01df62"
import script from "./license-agreement.vue?vue&type=script&lang=js"
export * from "./license-agreement.vue?vue&type=script&lang=js"
import style0 from "./license-agreement.vue?vue&type=style&index=0&id=7b01df62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports